{
    "CookiesDescription": "We use cookies to improve your experience of Akixi. To see more information about how and why we use cookies, please see our {}Cookie Policy{}.",
    "CookieConsentChangeMessage": "If you wish to change this setting you can do so below.",
    "AcceptedAllCookiesMessage": "You have accepted all cookies.\n{}",
    "AcceptedFunctionalCookiesMessage": "You have accepted functionality cookies only.\n{}",
    "RejectedAllCookiesMessage": "You have rejected all cookies. This will mean some functionality of the application will not work.\n{}",
    "AcceptAllCookies": "Accept All",
    "AcceptFunctionalityCookies": "Accept Functionality Cookies",
    "RevokeAllCookies": "Revoke All Consent",
    "RevokeStatisticsCookies": "Revoke Statistics Consent",
    "RejectAllCookies": "Reject All",
    "RejectionWarning": "Rejecting all cookies will mean that you may not be able to use all of the features of the application.\n\nIf you need to use these features in the future you will need to \"Accept Functionality Cookies\" on the Cookie Policy page.",
    "NAME": "CookieConsent"
}